import PagesWrapper from "../mainpage/PagesWrapper";
import styles from "./Vita.module.css";
import { imgVita } from "../../../media/vita/export";
import { Section } from "../../../types";

const Vita = ({ data, bgData }: { data: Section[]; bgData: Section[] }) => {
  return (
    <PagesWrapper
      data={bgData}
      header={"VITA"}
      header2={"uwe.s (Uwe Scheutzel)"}
      image={imgVita}
      hasTop
    >
      <div className={styles.sections}>
        {data.map((vita, index) => {
          return (
            <div key={index} className={styles.section}>
              <div className={styles.yearText}>
                <p>{vita.texts[0].content}</p>
              </div>
              <div
                dangerouslySetInnerHTML={{ __html: vita.texts[1].content }}
              ></div>
              <div>
                {vita.pictures.length > 0 && (
                  <img
                    src={vita.pictures[0].dataUrl}
                    alt={vita.id.toString()}
                  />
                )}
              </div>
            </div>
          );
        })}
      </div>
    </PagesWrapper>
  );
};

export default Vita;
